export default "__VITE_ASSET__BHeUYOza__"